import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class FloorPlansApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "floor_plans/";
	}

	updatePointFloorPlanLocations(updates, onSuccess, onError) {
		Promise.all(
			updates.map((item) =>
				fetch(item.id + "update_floor_plan_x_y/", {
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: this.getToken(),
					},
					body: JSON.stringify({
						x: item.x,
						y: item.y,
					}),
				})
			)
		)
			.then((responses) => {
				if (responses.every((r) => r.ok)) {
					onSuccess();
				} else {
					onError();
				}
			})
			.catch(() => {
				onError();
			});
	}
}
